import serviceADX from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
  //
  aggregated: {},
  energyData: {},
};

const mutations = {
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_AGGREGATED(state, payload) {
    state.aggregated = payload;
  },
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LOADING_LIST(state, value) {
    state.loading = value;
  },
  SET_ENERGY_DATA(state, value) {
    state.energyData = value;
  },
};

const actions = {
  setLoadingValue: (store, value) => {
    store.commit("SET_LOADING_LIST", value);
  },
  list: (store, params) => {
    store.state.loading = true;
    return serviceADX
      .get("bookings/charge-sessions", params)
      .then((data) => {
        store.commit("SET_META", data.body);
        store.commit("SET_AGGREGATED", data.body?.aggregate);
        store.commit("SET_LIST", data.body.data);
        return data.body.data;
      })
      .finally(() => (store.state.loading = false));
  },
  updateCustomerList: (store, params) => {
    // store.state.loading = true;
    return serviceADX
      .post("bookings/update-walkin-customer-data", params)
      .then((data) => {
        return data.body.data;
      })
      .finally(() => (store.state.loading = false));
  },
  downloadList: (store, params) => {
    store.state.loading = true;
    return serviceADX
      .get("bookings/charge-sessions-download", params)
      .then((data) => {
        return data.body;
      })
      .finally(() => (store.state.loading = false));
  },
  energyData: (store, params) => {
    store.state.loading = true;
    return serviceADX
      .get("bookings/charge-session-details", params)
      .then((data) => {
        store.commit("SET_ENERGY_DATA", data?.body);
        return data?.body;
      })
      .finally(() => (store.state.loading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getAggregated(state) {
    return state.aggregated;
  },
  getList(state) {
    return state.list;
  },
  getEnergyData(state) {
    return state.energyData;
  },
};

const csmsChargingSession = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default csmsChargingSession;
